import React from "react";

function ProjectIcon(props) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.25 14.6664V7.33308C19.2497 7.01158 19.1648 6.69582 19.0039 6.41748C18.843 6.13914 18.6118 5.908 18.3333 5.74725L11.9167 2.08058C11.638 1.91967 11.3218 1.83496 11 1.83496C10.6782 1.83496 10.362 1.91967 10.0833 2.08058L3.66667 5.74725C3.38824 5.908 3.15698 6.13914 2.99609 6.41748C2.8352 6.69582 2.75033 7.01158 2.75 7.33308V14.6664C2.75033 14.9879 2.8352 15.3037 2.99609 15.582C3.15698 15.8604 3.38824 16.0915 3.66667 16.2522L10.0833 19.9189C10.362 20.0798 10.6782 20.1645 11 20.1645C11.3218 20.1645 11.638 20.0798 11.9167 19.9189L18.3333 16.2522C18.6118 16.0915 18.843 15.8604 19.0039 15.582C19.1648 15.3037 19.2497 14.9879 19.25 14.6664Z"
        stroke="#EEEEEE"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.99609 6.37988L10.9986 11.009L19.0011 6.37988"
        stroke="#EEEEEE"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11 20.24V11"
        stroke="#EEEEEE"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default ProjectIcon;
